var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEcoModeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66675C5.40841 1.66675 1.66675 5.40841 1.66675 10.0001C1.66675 14.5917 5.40841 18.3334 10.0001 18.3334C14.5917 18.3334 18.3334 14.5917 18.3334 10.0001C18.3334 5.40841 14.5917 1.66675 10.0001 1.66675ZM10.0001 17.0834C6.09175 17.0834 2.91675 13.9084 2.91675 10.0001C2.91675 6.09175 6.09175 2.91675 10.0001 2.91675C13.9084 2.91675 17.0834 6.09175 17.0834 10.0001C17.0834 13.9084 13.9084 17.0834 10.0001 17.0834Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 6.0083C7.79997 6.0083 6.0083 7.79997 6.0083 9.99997V10.75H6.07497C6.42497 12.6 8.04997 14 9.99997 14C11.5666 14 13 13.075 13.65 11.6416L12.2833 11.025C11.875 11.925 10.9833 12.5 9.99997 12.5C8.8833 12.5 7.94163 11.7666 7.61663 10.7583H13.9916V10.0083C13.9916 7.8083 12.2 6.01663 9.99997 6.01663V6.0083ZM7.61663 9.24997C7.9333 8.24163 8.8833 7.5083 9.99997 7.5083C11.1166 7.5083 12.0583 8.24163 12.3833 9.24997H7.62497H7.61663Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEcoModeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Eco_Mode_Icon.bae5cecb4c37d45e0e9a4809f4a6291a.svg";